module.exports = __webpack_public_path__ + "static/media/99HEALTHLOGO.19434370.png";